import { useEffect } from 'react';

import { whenRumReady } from '../init-rum';
import { log } from '../log';
import { writeCachedAnalyticsConsent } from '../osano/analytics-consent-cache';
import { subscribeToAnalyticsConsent } from '../osano/subscribe-to-analytics-consent';
import { TTrackingConsent } from '../types';

/**
 * Applies Osano's ANALYTICS decision to the current session, and saves it so
 * `initRum` can honour it on the next page load. See ADR 20261015, "Privacy
 * position".
 *
 * Separate from `useRumUser`, which returns early inside the mobile webview —
 * folding consent into it would tie the two together for no reason.
 */
export const useRumTrackingConsent = (): void => {
  useEffect(() => {
    let isCancelled = false;
    let unsubscribe: (() => void) | undefined;

    void whenRumReady().then((rum) => {
      if (!rum || isCancelled) {
        return;
      }

      unsubscribe = subscribeToAnalyticsConsent((isGranted) => {
        const consent: TTrackingConsent = isGranted ? 'granted' : 'not-granted';

        log('tracking consent -> %s', consent);
        writeCachedAnalyticsConsent(isGranted);
        rum.setTrackingConsent(consent);
      });
    });

    return () => {
      isCancelled = true;
      unsubscribe?.();
    };
  }, []);
};
